import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  margin: 10px auto 0;

  padding: 1px;
  text-align: center;
  background-color: #182329ef;
  color: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1);
  border: 1px solid #555;
`;

const ContainerTexto = styled.div`
  text-align: left;
  color: #f5f5f5;
  margin: 20px 0;
`;

const Titulo = styled.h2`
  font-family: 'GarnetLight';
  font-size: 25px;
  color: #a0f000;
  text-align: center;
  padding: 20px 0 10px;
`;

const DownloadButton = styled.a`
  display: inline-block;
  margin: 15px auto 30px;
  padding: 10px 24px;
  background-color: #a0f000;
  color: #182329;
  font-weight: bold;
  border-radius: 5px;
  text-decoration: none;
    font-family: 'Kobern';
  cursor: pointer;

  &:hover {
    background-color: #b8ff00;
  }
`;

const NormasGenerales = () => {
  const pdfPath = "/PDF/normas generales 26-27.pdf";
  const pdfName = "normas generales 26-27.pdf";

  return (
    <Container>
      <ContainerTexto>
        <Titulo>normas generales 26 - 27</Titulo>
      </ContainerTexto>

      {/* Botón de descarga universal */}
      <DownloadButton href={pdfPath} download={pdfName}>
        DESCARGAR PDF
      </DownloadButton>
    </Container>
  );
};

export default NormasGenerales;





